import React from "react";
import {connect} from "react-redux";
import {Button, message, Modal, Space, Tooltip} from "antd";
import {
    CopyOutlined,
    ExclamationCircleOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
    QuestionCircleOutlined
} from "@ant-design/icons";
import RetweetOutlined from "@ant-design/icons/lib/icons/RetweetOutlined";
import {displayErrors} from "../../libs/utils";
import {regenerateCompanyWebhookSecret} from "../../actions/account";

class WebhookSecret extends React.Component {
    state = {
        showSecret: false,
    }

    regenerateSecret() {
        const { confirm } = Modal;

        confirm({
            title: 'Are you sure?',
            centered: true,
            okText: 'Regenerate',
            cancelText: 'Cancel',
            icon: <ExclamationCircleOutlined />,
            content: <p>Are you sure you wish to regenerate your webhook's secret?</p>,
            onOk: () => {
                this.props.regenerateCompanyWebhookSecret(this.props.company.guid, this.props.webhookId, () => {
                    message.success('Webhook secret successfully regenerated!');
                    this.props.reload();
                }, (err) => {
                    if(typeof err.response !== 'undefined') {
                        displayErrors(err.response.data);
                    }
                });
            }
        });
    }

    render() {
        let secret = '********************************';

        if(this.state.showSecret) {
            secret = this.props.secret;
        }

        return <Space>
            <span>{secret}</span>
            <Tooltip title={(this.state.showSecret ? 'Hide' : 'Show' ) + ' secret'}>
                <Button icon={this.state.showSecret ? <EyeInvisibleOutlined /> : <EyeOutlined />} type='text' size='small' onClick={() => this.setState({ showSecret: !this.state.showSecret})} />
            </Tooltip>
            <Tooltip title='Copy the secret'>
                <Button icon={<CopyOutlined />} type='text' size='small' onClick={() => {
                    navigator.clipboard.writeText(this.props.secret).then(() => {
                        message.success('The secret copied successfully!')
                    }, () => {
                        message.error('Failed to copy the password!')
                    });
                }} />
            </Tooltip>
            <Tooltip title='Regenerate the secret'>
                <Button icon={<RetweetOutlined />} type='text' size='small' onClick={() => this.regenerateSecret()} />
            </Tooltip>
            <a href='https://support.priorityprospect.com/knowledgebase/article/how-to-use-webhooks' rel='noreferrer noopener' target='_blank'>
                <Tooltip title='How to use secrets?'>
                    <Button icon={<QuestionCircleOutlined />} type='text' size='small' />
                </Tooltip>
            </a>
        </Space>
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});


export default connect(mapStateToProps, { regenerateCompanyWebhookSecret })(WebhookSecret);